import React from 'react';
import ReactMarkdown from 'react-markdown';

const markdownContent = `
## About Us

Seattle Street Bulletin is an independent, non-commercial documentary project that archives the ephemeral visual culture of Seattle’s streets—flyers, handbills, street art, zines, lost pet signs, and other public postings.

We are not affiliated with any individuals or organizations whose work appears here. We do not claim ownership of the posted materials, nor do we endorse or verify their accuracy or legality. These materials are documented in situ and reflect the perspectives of their original authors.

This project is strictly non-commercial. We do not sell advertising, collect user data, or accept sponsorships. Our goal is to preserve and share visual records of Seattle’s street-level expression.

We believe that our use of these materials constitutes fair use under U.S. copyright law, based on their documentary, educational, and non-commercial nature. However, we welcome requests for credit or takedown from rights holders and will respond promptly (seattlestreetbulletin@gmail.com).
`;

function About() {
  return (
    <div className="container">
      <ReactMarkdown>{markdownContent}</ReactMarkdown>
    </div>
  );
}

export default About;